import { compose, withProps } from 'recompose';
import AdminCpdCategoryEdit from './cpd-category-edit';

export default compose(
  withProps(

  )
)(AdminCpdCategoryEdit)


// WEBPACK FOOTER //
// ./src/containers/pages/admin-portal/cpd-category-portal/cpd-category-add.js